import { useState } from 'react';

export function useSelection<T>(): [
  T[],
  (checked: boolean, rowId: T) => void,
  (checked: boolean, rows: T[]) => void,
  () => void,
] {
  const [selectedRows, setSelectedRows] = useState<T[]>([]);

  const handleSelect = (checked: boolean, rowId: T): void => {
    setSelectedRows(prevSelectedRows => {
      if (checked) {
        return [...prevSelectedRows, rowId];
      }

      return prevSelectedRows.filter(selectedRow => selectedRow !== rowId);
    });
  };

  const handleClearSelected = (): void => {
    setSelectedRows([]);
  };

  const handleSelectAll = (checked: boolean, rows: T[]): void => {
    if (checked) {
      setSelectedRows(rows);
      return;
    }

    handleClearSelected();
  };

  return [selectedRows, handleSelect, handleSelectAll, handleClearSelected];
}
